import { loadMoonPay } from '@js-sdk';
import {
  ReactNode,
  createContext,
  useCallback,
  useEffect,
  useState,
} from 'react';
import { getEnvironmentFromApiKey } from '@common';
import { MoonPayInitFn, MoonPayWebSdkConfig } from '../types';

interface MoonPayProviderProps {
  children: ReactNode;
  apiKey: string;
  debug?: boolean;
}

type MoonPayContext = Omit<MoonPayProviderProps, 'children'> & {
  init?: MoonPayInitFn;
  environment: MoonPayWebSdkConfig['environment'];
};

export const MoonPayContext = createContext<MoonPayContext>({
  apiKey: '',
  environment: 'sandbox',
  debug: false,
});

export const MoonPayProvider = ({
  children,
  apiKey,
  debug = false,
}: MoonPayProviderProps) => {
  const environment = getEnvironmentFromApiKey(apiKey);

  const [contextState, setContextState] = useState<MoonPayContext>({
    apiKey,
    environment,
    debug,
  });

  const load = useCallback(async () => {
    const moonPay = await loadMoonPay();
    setContextState((state) => ({ ...state, init: moonPay }));
  }, []);

  useEffect(() => {
    if (!contextState.init) load();
  }, [load, contextState.init]);

  return (
    <MoonPayContext.Provider value={contextState}>
      {children}
    </MoonPayContext.Provider>
  );
};
